/**
 * Who sees the Account page's legal-texts card, and who may edit it.
 *
 * The tenant's own contract terms, so only the owner edits them. A master
 * viewing a tenant READS them: they are what the tenant's invoices and
 * acceptance mails carry (payment terms are required on an unpaid e-invoice),
 * and kolula staff must be able to see why issuance refuses. The save goes to
 * the own-account route, so anyone who is not the owner gets no save button.
 * Not for a legacy store viewed by a master: it has no tenant record to read.
 *
 * Decided here rather than inline on the Account page, whose render function
 * is already over the complexity budget.
 */
export const shownLegalTexts = (
    ownsTenant: boolean,
    isSelfService: boolean,
): { visible: boolean, editable: boolean } => ({
    visible: ownsTenant || isSelfService,
    editable: ownsTenant,
});
